import { useState } from 'react';
import { Download } from 'lucide-react';
import { api } from '@/shared/lib/axios.ts';

interface Props {
  url: string;
  params?: Record<string, string | undefined>;
  filename: string;
  label: string;
  disabled?: boolean;
}

async function downloadReport(url: string, filename: string, params?: Record<string, string | undefined>) {
  const cleanParams: Record<string, string> = {};
  if (params) {
    for (const [k, v] of Object.entries(params)) {
      if (v !== undefined) cleanParams[k] = v;
    }
  }
  const res = await api.get(url, { params: cleanParams, responseType: 'blob' });
  const href = URL.createObjectURL(res.data as Blob);
  const a = document.createElement('a');
  a.href = href;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(href);
}

export function DownloadButton({ url, params, filename, label, disabled }: Props) {
  const [loading, setLoading] = useState(false);

  async function handleClick() {
    if (loading || disabled) return;
    setLoading(true);
    try {
      await downloadReport(url, filename, params);
    } catch {
      // silently fail — could add toast here
    } finally {
      setLoading(false);
    }
  }

  return (
    <button
      type="button"
      onClick={handleClick}
      disabled={loading || disabled}
      className="flex items-center gap-1.5 rounded-md border border-gray-300 px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-40 dark:border-gray-600 dark:text-gray-300 dark:hover:bg-gray-800"
    >
      <Download size={14} className={loading ? 'animate-spin' : ''} />
      {loading ? 'Gerando...' : label}
    </button>
  );
}
